/**
 * The one hosted environment where real school-material learning may run:
 * the invite-only staging project for the PO's family test
 * (docs/development/staging-deployment-readiness.md).
 *
 * The exact project URL is pinned here, in reviewed source, not in a build
 * variable, so a build cannot point the learning journeys at another hosted
 * project by changing its environment. Null would make every `staging`
 * build refuse to start. Changing it needs a reviewed commit and PO approval.
 */
export const STAGING_SUPABASE_URL: string | null =
  'https://escsklnruvpqpftiryll.supabase.co' // ai-learning-companion-staging, ap-south-1 (PO, 2026-11-03)

const HOSTED_PROJECT_URL = /^https:\/\/[a-z0-9]{20}\.supabase\.co$/

/** True only for the exact, well-formed, approved staging project URL. */
export function isApprovedStagingUrl(
  url: string,
  approved: string | null = STAGING_SUPABASE_URL,
): boolean {
  return approved !== null && HOSTED_PROJECT_URL.test(approved) && url === approved
}
